module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Agriculture","primaryCrop":"Primary Crop","noDetails":"No details yet."},"es":{"title":"Cultivo","primaryCrop":"Cultivo principal","noDetails":"Aún no hay detalles."},"sw":{"title":"Kilimo","primaryCrop":"Mazao ya Msingi","noDetails":"Hakuna maelezo bado."}}')
  delete Component.options._Ctor
}
